import { createIcon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const RouteRoadmapSvg: (props: IconProps) => JSX.Element = createIcon({
  displayName: `RouteRoadmapSvg`,
  viewBox: `0 0 32 32`,
  path: (
    <>
      <path
        opacity="0.12"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 10.6667C26.2091 10.6667 28 8.8758 28 6.66666C28 4.45752 26.2091 2.66666 24 2.66666C21.7909 2.66666 20 4.45752 20 6.66666C20 8.8758 21.7909 10.6667 24 10.6667ZM6.66666 29.3333C8.8758 29.3333 10.6667 27.5425 10.6667 25.3333C10.6667 23.1242 8.8758 21.3333 6.66666 21.3333C4.45752 21.3333 2.66666 23.1242 2.66666 25.3333C2.66666 27.5425 4.45752 29.3333 6.66666 29.3333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 3.41666C22.2051 3.41666 20.75 4.87173 20.75 6.66666C20.75 8.46158 22.2051 9.91666 24 9.91666C25.7949 9.91666 27.25 8.46158 27.25 6.66666C27.25 4.87173 25.7949 3.41666 24 3.41666ZM19.25 6.66666C19.25 4.0433 21.3766 1.91666 24 1.91666C26.6233 1.91666 28.75 4.0433 28.75 6.66666C28.75 9.29001 26.6233 11.4167 24 11.4167C21.3766 11.4167 19.25 9.29001 19.25 6.66666ZM6.66666 22.0833C4.87173 22.0833 3.41666 23.5384 3.41666 25.3333C3.41666 27.1283 4.87173 28.5833 6.66666 28.5833C8.46158 28.5833 9.91666 27.1283 9.91666 25.3333C9.91666 25.333 9.91666 25.3326 9.91666 25.3322C9.91607 23.5378 8.46122 22.0833 6.66666 22.0833ZM11.3578 24.5833C10.9982 22.3163 9.03481 20.5833 6.66666 20.5833C4.0433 20.5833 1.91666 22.71 1.91666 25.3333C1.91666 27.9567 4.0433 30.0833 6.66666 30.0833C9.03481 30.0833 10.9982 28.3503 11.3578 26.0833H22C24.9915 26.0833 27.4167 23.6582 27.4167 20.6667C27.4167 17.6751 24.9915 15.25 22 15.25H8.66665C6.50354 15.25 4.74999 13.4964 4.74999 11.3333C4.74999 9.17021 6.50354 7.41666 8.66666 7.41666H14.1893L12.1363 9.46966C11.8434 9.76255 11.8434 10.2374 12.1363 10.5303C12.4292 10.8232 12.9041 10.8232 13.197 10.5303L16.5303 7.19699C16.8232 6.90409 16.8232 6.42922 16.5303 6.13633L13.197 2.80299C12.9041 2.5101 12.4292 2.5101 12.1363 2.80299C11.8434 3.09589 11.8434 3.57076 12.1363 3.86365L14.1893 5.91666H8.66666C5.67511 5.91666 3.24999 8.34178 3.24999 11.3333C3.24999 14.3249 5.67511 16.75 8.66665 16.75H22C24.1631 16.75 25.9167 18.5035 25.9167 20.6667C25.9167 22.8298 24.1631 24.5833 22 24.5833H11.3578Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    width: `100%`,
    height: `100%`,
    fill: `none`,
  },
});

export default RouteRoadmapSvg;
